import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';

export default function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      await signIn(email, password);
      const dest = location.state?.from?.pathname || '/';
      navigate(dest, { replace: true });
    } catch (err) {
      setError(err?.data?.error || err?.message || 'Could not sign in');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-hxd-body flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <div className="text-center mb-7">
          <Link to="/" className="block">
            <div className="flex w-full h-1 mb-6">
              <span className="bg-hxd-orange flex-[45]" />
              <span className="bg-white flex-[10]" />
              <span className="bg-black flex-[45]" />
            </div>
            <h1 className="font-display text-[20px] font-bold tracking-display-sm uppercase m-0">
              Hangar<span className="text-hxd-orange">X</span> Daily
            </h1>
          </Link>
          <p className="text-[13px] text-hxd-muted mt-1">Sign in to your account</p>
        </div>

        <form onSubmit={onSubmit} className="hxd-card space-y-4" noValidate>
          {error && (
            <div
              role="alert"
              className="text-[13px] text-[#c0392b] bg-[#fdecea] border border-[#f5c6cb] rounded px-3 py-2"
            >
              {error}
            </div>
          )}
          <div>
            <label className="hxd-label" htmlFor="email">Email</label>
            <input
              id="email"
              className="hxd-input"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>
          <div>
            <label className="hxd-label" htmlFor="password">Password</label>
            <input
              id="password"
              className="hxd-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            className="hxd-btn hxd-btn-primary w-full text-[15px] py-3"
            disabled={submitting}
          >
            {submitting ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-[13px] text-[#666] mt-5">
          Don&apos;t have an account?{' '}
          <Link to="/signup" className="text-hxd-orange font-bold">
            Become a Subscriber →
          </Link>
        </p>
        <p className="text-center text-[12px] text-hxd-subtle mt-2">
          <Link to="/" className="hover:text-hxd-orange">
            ← Back to today&apos;s brief
          </Link>
        </p>
      </div>
    </div>
  );
}
